/** PUBLIC — DPDP-aligned privacy notice + the three required affirmations. Nothing is pre-ticked. */
export function NoticePanel({ notice }) {
  return (
    <div className="max-h-[340px] overflow-y-auto rounded-xl border border-slate-200 bg-slate-50 p-4 sm:p-5 space-y-3" data-testid="onb-notice" tabIndex={0} aria-label="Privacy notice">
      {notice.sections.map((s) => (
        <div key={s.title}>
          <h3 className="text-[13px] font-semibold text-slate-900">{s.title}</h3>
          <p className="text-[13px] leading-relaxed text-slate-700 whitespace-pre-line break-words">{s.text}</p>
        </div>
      ))}
      <p className="text-[11px] text-slate-500 pt-2 border-t border-slate-200" data-testid="onb-notice-version">
        Notice version {notice.version}{notice.effective_date ? ` · effective ${notice.effective_date}` : ""}. This notice is separate from quotation and order terms.
      </p>
    </div>
  );
}

const CHECKS = [
  ["notice_read", "I have read the privacy notice above."],
  ["purpose_consent", "I agree that SUNTRONIX may use these details for the purposes listed in the notice: customer record, quotations and orders, invoicing, shipping and support / service coordination."],
  ["authorised", "I am authorised to act for this organisation (or I am the individual customer), and authorised to share the details of any other contacts I add."],
];

export function ConsentChecks({ value, onChange }) {
  return (
    <div className="space-y-3" data-testid="onb-consents">
      {CHECKS.map(([k, label]) => (
        <label key={k} className="flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-3 cursor-pointer hover:border-slate-300 transition-colors">
          <input type="checkbox" className="mt-0.5 h-4 w-4 accent-sky-700" checked={!!value[k]} onChange={(e) => onChange({ ...value, [k]: e.target.checked })} data-testid={`onb-consent-${k}`} />
          <span className="text-[13px] leading-relaxed text-slate-800">{label}</span>
        </label>
      ))}
      <p className="text-[11.5px] text-slate-500">No marketing permission is requested. Each person whose details you share keeps their own privacy rights.</p>
    </div>
  );
}
